import React from "react";
import styled from "styled-components";
import useSpeedShopping from "../../screens/subscriber/speedShopping/hooks/useSpeedShopping";
import { CardCurve, CheckCirclIcon, PlusIcon } from "../svgs";
import { Button, DynamicButton } from "./basic";
import QuantityControl from "./quantityControl";

const ProductItem = ({
  title,
  image,
  id,
  isSelected,
  func,
  background,
  price,
  quantity,
  setShowLimitDialog,
  decreaseCartItem,
  ...rest
}) => {
  const { cartCost } = useSpeedShopping();

  return (
    <ProductContainer {...rest}>
      {/* <ProductItemButton
        onClick={() => {
          cartCost + price > 500 ? setShowLimitDialog(true) : func();
        }}
        isSelected={isSelected}
        color={background}
      /> */}
      <ProductImage objectFit={"cover"} alt={title} src={image} />

      <div
        style={{
          display: "flex",
          borderBottomLeftRadius: 20,
          borderBottomRightRadius: 20,
          justifyContent: "left",
          textAlign: "left",
          flexDirection: "column",
          padding: "0 8px",
        }}
      >
        <ProductTitle style={{ textAlign: "left", margin: "0px" }} size={14}>
          {title}
        </ProductTitle>
        <ProductTitle
          style={{ textAlign: "left" }}
          color='#E31C79'
          marginBottom={0}
        >{`GHS ${price}`}</ProductTitle>
      </div>
      <div style={{ padding: "8px 0" }}>
        {isSelected ? (
          <QuantityControlHolder>
            <QuantityControl
              iconBackground={background}
              increment={() => {
                cartCost + price > 500 ? setShowLimitDialog(true) : func();
              }}
              decrement={() => decreaseCartItem()}
              value={quantity}
              isCompact={false}
              isEditable={false}
            />
          </QuantityControlHolder>
        ) : (
          <DynamicButton
            padding={"2px 10px"}
            label={"Add to cart"}
            color={background}
            textColor={"#fff"}
            width={"90%"}
            height={"28px"}
            onClick={() => {
              cartCost + price > 500 ? setShowLimitDialog(true) : func();
            }}
          />
        )}
      </div>
    </ProductContainer>
  );
};

const ProductItemButton = ({ isSelected, color, onClick }) => (
  <ProductItemButtonContainer
    color={color}
    backgroundColor={isSelected ? "#fff" : color}
    onClick={onClick}
  >
    {!isSelected ? (
      <PlusIcon color={"#fff"} fill={color} width={32} />
    ) : (
      <CheckCirclIcon color={color} fill={"#fff"} width={32} />
    )}
  </ProductItemButtonContainer>
);

const ProductContainer = styled.div`
  box-sizing: border-box;
  padding: 15px 0px 0px 0px;
  border-radius: 20px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  width: 142px;
  height: 194px;
  position: relative;
  margin: 0 1% 24px 1%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ProductItemButtonContainer = styled.div`
  border: 3.5px solid ${(prop) => prop.color};
  background: ${(prop) => prop.backgroundColor};
  box-sizing: border-box;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  position: absolute;
  top: 5px;
  right: 5px;
`;

const ProductTitle = styled.div`
  font-family: "MTNBold";
  font-size: ${({ size = 10 }) => `${size}px`};
  margin-bottom: ${({ marginBottom = 10 }) => `${marginBottom}px`};
  text-align: center;
  color: ${({ color = "black" }) => color};
`;

const ProductImage = styled.img`
  object-fit: ${({ objectFit = "contain" }) => objectFit};
  object - position: center center;
  width: 100%;
  height: 87px;
`;

const QuantityControlHolder = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px 0 8px;
  justify-content: center;
`;

export default ProductItem;
